import { orchestrator } from 'satcheljs';
import {
    updateCalendarCloudSettings,
    setShouldEventsEndEarly,
    setEndShortEventsBy,
    setEndLongEventsBy,
    setEnableOnlineMeetingsByDefault,
    setShortenEventScope,
} from '../actions/internalActions';

orchestrator(updateCalendarCloudSettings, actionMessage => {
    const { calendarCloudSettings } = actionMessage;

    if (calendarCloudSettings.shouldEventsEndEarly != null) {
        setShouldEventsEndEarly(calendarCloudSettings.shouldEventsEndEarly);
    }

    if (calendarCloudSettings.shortenEventScope != null) {
        setShortenEventScope(calendarCloudSettings.shortenEventScope);
    }

    if (calendarCloudSettings.endShortEventsBy != null) {
        setEndShortEventsBy(calendarCloudSettings.endShortEventsBy);
    }

    if (calendarCloudSettings.endLongEventsBy != null) {
        setEndLongEventsBy(calendarCloudSettings.endLongEventsBy);
    }

    if (calendarCloudSettings.enableOnlineMeetingsByDefault != null) {
        setEnableOnlineMeetingsByDefault(calendarCloudSettings.enableOnlineMeetingsByDefault);
    }
});
